import * as ss from 'superstruct';
import { Id } from '../../types';

export const AdSources: [
  'google',
  'meta',
  'bing',
  'linkedin',
  'reddit',
  'openai',
  'email',
] = [
  'google',
  'meta',
  'bing',
  'linkedin',
  'reddit',
  'openai',
  'email',
] as const;

export type AdSources = (typeof AdSources)[number];

/** Display name of each ad source, e.g. for seeded paid source names. */
export const AdSourceLabels: Record<AdSources, string> = {
  google: 'Google',
  meta: 'Meta',
  bing: 'Bing',
  linkedin: 'LinkedIn',
  reddit: 'Reddit',
  openai: 'OpenAI',
  email: 'Email',
};

/**
 * Channels the hourly add-common-paid-sources job seeds a "{Name} | Other"
 * PaidSource for.  Email is excluded: it isn't paid spend and has no
 * account/campaign granularity, so orgs create that row by hand only if they
 * want a tracked call or URL for it.
 */
export const AutoSeededAdSources: readonly AdSources[] = [
  'google',
  'meta',
  'bing',
  'linkedin',
  'reddit',
  'openai',
];

export const PaidSourceResource = ss.type({
  id: Id,
  /** Optional name to describe the source. */
  name: ss.optional(ss.nullable(ss.string())),
  /** Which Ad network? */
  adSource: ss.enums(AdSources),
  /**
   * Optional account ID of the ad source, in case their are multiple. Writes
   * normalize it per `adSource`; see `AdAccountIdRules`.
   */
  accountId: ss.optional(ss.nullable(ss.string())),
  /** Optional campaign ID associated with LP. */
  campaignId: ss.optional(ss.nullable(ss.string())),
  /** Optional Ad Group ID associated with LP. */
  adGroupId: ss.optional(ss.nullable(ss.string())),
  /** Optional Ad ID associated with LP. */
  adId: ss.optional(ss.nullable(ss.string())),
});

export type PaidSourceResource = ss.Infer<typeof PaidSourceResource>;
